import { useEffect, useState } from "react";

/**
 * Discreet gold sparkle shower — 24 small golden dots that fall & fade over ~2.2s.
 * Renders inside a fixed-position full-viewport overlay when `show` becomes true.
 */
export const SparkleShower = ({ show }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!show) return;
    setVisible(true);
    const t = setTimeout(() => setVisible(false), 2600);
    return () => clearTimeout(t);
  }, [show]);

  if (!visible) return null;

  const sparkles = Array.from({ length: 26 });
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none fixed inset-0 z-40 overflow-hidden"
      data-testid="sparkle-shower"
    >
      {sparkles.map((_, i) => (
        <span
          key={i}
          className="sparkle"
          style={{
            left: `${5 + Math.random() * 90}%`,
            animationDelay: `${Math.random() * 0.6}s`,
            animationDuration: `${1.8 + Math.random() * 1.2}s`,
            width: `${6 + Math.random() * 8}px`,
            height: `${6 + Math.random() * 8}px`,
          }}
        />
      ))}
    </div>
  );
};

export default SparkleShower;
